import React, { Component } from "react";
import { connect } from "react-redux";
import "../styles/Home.css";
import { GoogleApiWrapper } from 'google-maps-react';
import Map from 'google-map-react';
import { Table, Row, Col, Pagination } from "antd";
import moment from "moment-timezone";
import Station from "../components/Station";
// import createDeepstream from 'deepstream.io-client-js';
import carLogo from "../assets/maint_icon.png";
import disponible from "../assets/disponible.png";
import cargando from "../assets/cargando.png";
import ocupados from "../assets/ocupados.png";
import slots from "../assets/slots.png";


class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showingInfoWindow: false,
			activeMarker: {},
			selectedPlace: {},
			station: null,
			center: {
				lat: 25.69692491101017,
				lng: -100.31731374281587
			},
			cars: [
				{
					lat: 25.695859,
					lng: -100.316909
				},
				{
					lat: 25.698002,
					lng: -100.32094
				}
			],
			columns: [
				{
					title: 'Fecha Inicio',
					dataIndex: 'timestamp_beginning',
					key: 'timestamp_beginning',
					align: 'center',
					render: d => (
						moment(d).tz("America/Monterrey").format("DD/MM/YYYY HH:mm:ss").toString()
					)
				},
				{
					title: 'Fecha Fin',
					dataIndex: 'timestamp_end',
					key: 'timestamp_end',
					align: 'center',
					render: d => (
						moment(d).tz("America/Monterrey").format("DD/MM/YYYY HH:mm:ss").toString()
					)
				},
				{
					title: 'Empresa',
					dataIndex: 'company',
					key: 'company',
					align: 'center'
				},
				{
					title: 'Estacion',
					dataIndex: 'name',
					key: 'name',
					align: 'center'
				},
				{
					title: 'kWh',
					dataIndex: 'kwh',
					key: 'kwh',
					align: 'center',
					render: d => d > 0 ? (d.toFixed(5)) : ("Cerrado")
				},
				{
					title: 'Costo',
					dataIndex: 'cost',
					key: 'cost',
					align: 'center',
					render: d => d > 0 ? ("$" + d.toFixed(5)) : ("Cerrado")
				},
			],
			current: 1
		}
		// try {
		// 	this.ds = createDeepstream("wss://unraitte.net:9090/deepstream");
		// 	this.ds.on("error", error => console.log);
		// 	this.ds.on("connectionStateChanged", () => null)
		// 	this.client = this.ds.login();
		//   } catch (err) {
		//   }
	}

	onMarkerClick = (a, b) => {
		this.setState({ station: b })
	}

	onMapLoaded = ({ map, maps }) => {
		this.map = map;
		this.maps = maps;
		this.infoWindow = new maps.InfoWindow();

	}

	onMapClicked = (props) => {
	};

	renderStations = () => {
		const { stations } = this.props;
		if (stations.data) {
			return this.props.stations.data.map((station, key) => {
				const lat = station.position[0];
				const lng = station.position[1];
				return (
					<Station
						key={key}
						data={station}
						lat={lat}
						lng={lng}
					/>
				)
			});
		}
	}

	renderIndicator = (item, i) => {
		let { charge, charging } = item;
		charge = charge ? charge : 0;
		let contadorExterior, contadorCentro;
		if (charging) {
			if (charge >= 0 && charge <= 19) {
				contadorExterior = ("c15");
				contadorCentro = ("b15");
			} else if (charge > 19 && charge <= 35) {
				contadorExterior = ("c33");
				contadorCentro = ("b33");
			} else if (charge > 35 && charge <= 60) {
				contadorExterior = ("c50");
				contadorCentro = ("b50");
			} else if (charge > 60 && charge <= 70) {
				contadorExterior = ("c66");
				contadorCentro = ("b66");
			} else if (charge > 70 && charge <= 93) {
				contadorExterior = ("c85");
				contadorCentro = ("b85");
			} else if (charge > 93 && charge <= 99) {
				contadorExterior = ("c85");
				contadorCentro = ("b100");
			} else if (charge === 100) {
				contadorCentro = ("b100");
				contadorExterior = ("c100");
			}
		} else {
			contadorExterior = (" c0");
			contadorCentro = ("b0");
		}

		return (
			<div key={i} className="contenedor">
				<div className="figura row">
					<div className="col-sm-8">
						<div>
							<img id="contadorExterior" className={`contador-img ${contadorExterior}`} alt="" src="images/en-espera-0.png" />
							<img id="contadorCentro" className={`contador-img ${contadorCentro}`} alt="" src="images/en-espera.png" />
							{charging && <span id="contador" className="h1 contador-text">{charge > 0 ? charge + "%" : "Conectar"}</span>}
						</div>
					</div>
					<br />
				</div>
			</div>
		)
	}

	async componentDidUpdate() {
	}


	onChange = page => {
		console.log(page);
		this.setState({
			current: page,
		});
	};

	isMobileDevice() {
		return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
	};


	render() {
		const isMobile = this.isMobileDevice();

		const slotHeader = (
			<Col span={24} id="status-home" style={ isMobile ? { width: '100%', margin: 0, display: "flex",  alignItems: "center" } : {}}>
				<div class="statusHome">
					<img alt="" src={slots} /> Slots totales
				</div>
				<div class="statusHome">
					<img alt="" src={ocupados} /> Slots ocupados
				</div>
				<div class="statusHome">
					<img alt="" src={cargando} /> Slots cargando
				</div>
				<div class="statusHome">
					<img alt="" src={disponible} /> Slots disponibles
				</div>
			</Col>
		);

		const map = (
			<Map
				ref={r => this.map = r}
				bootstrapURLKeys={this.props.google}
				style={{ width: '100%', height: isMobile ? 350 : 855, zIndex: -1 }}
				defaultZoom={15}
				onGoogleApiLoaded={this.onMapLoaded}
				yesIWantToUseGoogleMapApiInternals
				onChildClick={this.onMarkerClick}
				defaultCenter={this.state.center}
			>
				{this.renderStations()}
				{this.state.cars.map((c, k) => {
					return (
						<img src={carLogo} alt="" key={k} lat={c.lat} lng={c.lng}></img>
					)
				})}
			</Map>
		);

		const table = (
			<Table
				rowClassName={"animated fadeIn"}
				dataSource={this.props.loads}
				columns={this.state.columns}
				rowKey="id"
				pagination={{
					current: this.state.current,
					style: { display: 'none' }
				}}
			/>
		);

		return (
			<div>
				{isMobile ?
					<div>
						<Row>
							{slotHeader}
							<Col span={24}> {map} </Col>
						</Row>
						<br />
						<br />
						<Row>
							<Col span={24} style={{width: '100%',  fontSize: 8 }}>	{table} </Col>
						</Row>
					</div>
					:
					<div>
						<Row style={{}}>
							
							<Col span={8}> {map} </Col>
							<Col span={16} style={{ paddingLeft: 30 }}> {table} </Col>
							
						</Row>
					</div>
				}

				<Row style={{ flex: 1, width: '100%', marginTop: 25, textAlign: 'center' }}>
					<Pagination
						total={this.props.loads.length}
						current={this.state.current}
						onChange={this.onChange}
						style={{ width: '100%' }}
					/>
					{slotHeader}
				</Row>
			</div>
		)
	}
}
const mapStateToProps = state => {
	return { app: state.firebase, stations: state.stations, loads: state.loads.data }
}
export default connect(mapStateToProps)(
	GoogleApiWrapper({
		apiKey: "AIzaSyBRt5tonSSUXJvKCIu4eZhDsjn8mEMOMl8"
	})(Home)
);
